export const TRIAL_DURATION_DAYS = 7;

export type BillingCycle = 'monthly' | 'yearly';
export type PlanCode = 'lyfty_light';

export interface Plan {
  code: PlanCode;
  /** Marketing display name. */
  name: string;
  /** Price in dinars (millimes are not used for subscription pricing). */
  monthlyPrice: number;
  yearlyPrice: number;
  currency: 'TND';
}

export const PLAN_LYFTY_LIGHT: Plan = {
  code: 'lyfty_light',
  name: 'Gesty Light',
  monthlyPrice: 20,
  yearlyPrice: 190,
  currency: 'TND',
};

export const PLANS: Record<PlanCode, Plan> = {
  lyfty_light: PLAN_LYFTY_LIGHT,
};

export function priceForCycle(plan: Plan, cycle: BillingCycle): number {
  return cycle === 'yearly' ? plan.yearlyPrice : plan.monthlyPrice;
}

/** What the yearly plan costs per month, for the marketing comparison. */
export function yearlyMonthlyEquivalent(plan: Plan): number {
  return plan.yearlyPrice / 12;
}

/** Saved DT per year vs paying monthly. */
export function yearlySavingsAbsolute(plan: Plan): number {
  return plan.monthlyPrice * 12 - plan.yearlyPrice;
}

/** Same but as a percent (rounded). */
export function yearlySavingsPercent(plan: Plan): number {
  const saved = yearlySavingsAbsolute(plan);
  const fullYear = plan.monthlyPrice * 12;
  if (fullYear <= 0) return 0;
  return Math.round((saved / fullYear) * 100);
}
